



















































































import { Component } from 'vue-property-decorator';

import DragDrop from '@/components/DragDrop/DragDropElement.vue';
import { Gradient } from '@/components/wobble/model';
import Chapter from './Chapter.vue';
import AnimatedTextIteration from '@/components/AnimatedTextIteration.vue';
import FloatingWobble from '@/components/wobble/FloatingWobble.vue';

@Component({
  components: {
    FloatingWobble,
    DragDrop,
    AnimatedTextIteration
  }
})
export default class DragDropChapter extends Chapter {
  public wobbleGradient = new Gradient(
    '#e96b10',
    '#fce417',
    0.0,
    1.0,
    420.97,
    -235.8,
    147.67,
    535.89,
  );

  public startReflection = false;
  public startTouching = false;
  public dragDropInstructions = [
    'rearrange the forms in a new order',
    'notice how the new order makes you feel',
  ];
  public reflectionInstructions = [
    'Do you feel<br>nervousness?',
    'Or maybe<br>balance?',
    'Where is this sensation arising?',
    'Now, take an item on your desk that one of the forms reminds you of',
  ];
  public touchInstructions = [
    'feel it closely with your fingertips',
    'pay close attention:<br>weight, edges, surface',
    'can you also feel yourself holding the item?',
  ];

  chapterActivated() {
    this.lockScroll();
  }

  public proceedToNextChapter() {
    this.releaseScroll();
    this.goToNextChapter();
  }
}
